export const WIRE_UPLOAD_FORMAT_CONTAINER_TAG_NAME = 'wire-upload-format-container';
